export enum LiabilityType {
  MORTGAGE = 'Mortgage',
  PERSONAL_LOAN = 'PersonalLoan',
  CREDIT_CARD = 'CreditCard',
  OTHER = 'Other'
}
